// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserProfileSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserProfileSettingsQuery = { __typename?: 'Query', isUserLoggedInToAddepar: { __typename?: 'IsLoggedInToAddepar', isLoggedIn: boolean, externalUserName?: string | null }, isUserLoggedInToBlackDiamond: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, externalUserName?: string | null }, isUserLoggedInToOrion: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, externalUserName?: string | null }, isUserLoggedInToEMoney: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, externalUserName?: string | null }, integrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string, addeparFirmID?: string | null, blackDiamondEnabled: boolean, orionEnabled: boolean, emoneyEnabled: boolean } | null };

export const Operations = {
  Query: {
    GetUserProfileSettings: 'GetUserProfileSettings' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetUserProfileSettingsDocument = gql`
    query GetUserProfileSettings {
  isUserLoggedInToAddepar {
    isLoggedIn
    externalUserName
  }
  isUserLoggedInToBlackDiamond {
    isLoggedIn
    externalUserName
  }
  isUserLoggedInToOrion {
    isLoggedIn
    externalUserName
  }
  isUserLoggedInToEMoney {
    isLoggedIn
    externalUserName
  }
  integrationConfiguration {
    id
    addeparFirmID
    blackDiamondEnabled
    orionEnabled
    emoneyEnabled
  }
}
    `;

/**
 * __useGetUserProfileSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserProfileSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>(GetUserProfileSettingsDocument, withFetchPolicyContext(options));
      }
export function useGetUserProfileSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>(GetUserProfileSettingsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetUserProfileSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>(GetUserProfileSettingsDocument, withFetchPolicyContext(options));
        }
export type GetUserProfileSettingsQueryHookResult = ReturnType<typeof useGetUserProfileSettingsQuery>;
export type GetUserProfileSettingsLazyQueryHookResult = ReturnType<typeof useGetUserProfileSettingsLazyQuery>;
export type GetUserProfileSettingsSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSettingsSuspenseQuery>;
export type GetUserProfileSettingsQueryResult = Apollo.QueryResult<GetUserProfileSettingsQuery, GetUserProfileSettingsQueryVariables>;